(function () {
  const normalize = function (value) {
    return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  };
  const stopWords = new Set('a an and are as at be can could do does for from get how i in is it me my of on or please the this to what when where which with would you your'.split(' '));
  const keywords = {
    shipping: 'ship shipping delivery deliver dispatch tracking track transit postage international overseas arrival arrive package parcel delay delayed late address destination',
    'order-payment': 'order orders payment payments pay paid billing bill card cards credit debit checkout invoice cancel cancellation charge charged purchase purchasing',
    'returns-refunds': 'return returns refund refunds exchange exchanges damage damaged broken defective wrong reimbursement reimburse'
  };

  function initialize(scope) {
    const roots = scope.matches && scope.matches('.rudca-faq-page') ? [scope] : scope.querySelectorAll('.rudca-faq-page');
    roots.forEach(function (root) {
      const form = root.querySelector('.search.search-full');
      const input = form && form.querySelector('input[name="query"]');
      const cards = Array.from(root.querySelectorAll('a.dFlexitem'));
      if (!form || !input || !cards.length || form.dataset.faqSearchReady) return;
      form.dataset.faqSearchReady = 'true';

      const strings = JSON.parse(root.querySelector('[data-faq-search-strings]').textContent);
      const id = 'rudca-faq-' + root.dataset.sectionId.replace(/[^a-zA-Z0-9_-]/g, '-');
      const results = cards[0].parentElement;
      results.id = id + '-results';
      form.setAttribute('role', 'search');
      form.setAttribute('aria-label', strings.label);
      input.placeholder = strings.label;
      input.setAttribute('aria-label', strings.label);
      input.setAttribute('aria-controls', results.id);
      input.setAttribute('aria-describedby', id + '-description ' + id + '-status');

      const description = document.createElement('p');
      description.id = id + '-description';
      description.className = 'rudca-faq-search-description';
      description.textContent = strings.description;
      form.insertAdjacentElement('afterend', description);

      const status = document.createElement('p');
      status.id = id + '-status';
      status.className = 'rudca-faq-search-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      description.insertAdjacentElement('afterend', status);

      const reset = document.createElement('button');
      reset.type = 'button';
      reset.className = 'rudca-faq-reset';
      reset.textContent = strings.clear;
      reset.hidden = true;
      form.appendChild(reset);

      const entries = cards.map(function (card) {
        const path = new URL(card.href, window.location.href).pathname.split('/').filter(Boolean).pop();
        return {card: card, words: normalize(card.textContent + ' ' + (keywords[path] || '')).match(/[\p{L}\p{N}]+/gu) || []};
      });

      function update() {
        const query = input.value.trim();
        const terms = (normalize(query).match(/[\p{L}\p{N}]+/gu) || []).filter(function (term) { return !stopWords.has(term); });
        let count = 0;
        entries.forEach(function (entry) {
          const matches = !query || terms.some(function (term) {
            return entry.words.some(function (word) { return word.startsWith(term); });
          });
          entry.card.hidden = !matches;
          if (matches) count += 1;
        });
        reset.hidden = !input.value;
        status.textContent = query && !count ? strings.none.replace('__QUERY__', query) : (count === 1 ? strings.one : strings.many.replace('__COUNT__', String(count)));
      }

      function updateUrl() {
        const url = new URL(window.location.href);
        if (input.value.trim()) url.searchParams.set('query', input.value.trim());
        else url.searchParams.delete('query');
        url.searchParams.delete('utf8');
        url.searchParams.delete('commit');
        window.history.replaceState(window.history.state, '', url.href);
      }

      input.addEventListener('input', update);
      input.addEventListener('search', function () { update(); updateUrl(); });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        update();
        updateUrl();
      });
      reset.addEventListener('click', function () {
        input.value = '';
        update();
        updateUrl();
        input.focus();
      });
      window.addEventListener('popstate', function () {
        input.value = new URL(window.location.href).searchParams.get('query') || '';
        update();
      });
      input.value = new URL(window.location.href).searchParams.get('query') || input.value;
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
